import React from "react";
import { Title } from "@src/components";

function RevenueList() {
    return (
        <div>
            <Title />
        </div>
    );
}

export default RevenueList;
